<div [ngClass]="isMobile ? 'mobile' : 'desktop'">
  <div class="d-flex align-items-center" [style.height]="isMobile ? '56px' : '0px'">
    <div
      class="toggle menu-button ms-3"
      [ngClass]="{ 'menu-hidden': isExpanded }"
      (click)="$event.stopPropagation(); handleSidebarToggle()"
      >
      <span class="icon-menu menu-left"></span>
    </div>
    <img class="mobile-logo" alt="logo" [src]="isMerckTenant ? './assets/Images/logo-merck.svg' : './assets/Images/Logo2.png'" />
    @if (isMobile) {
      <div class="ms-auto d-flex align-items-center mobile-helpmode-toggle">
        <label class="custom-switch">
          <input type="checkbox" [checked]="isTooltipEnabled" (change)="tooltipEnabledChange.emit($any($event.target).checked)">
          <span class="switch-track" [class.on]="isTooltipEnabled">
            <span class="switch-thumb" [class.on]="isTooltipEnabled"></span>
          </span>
        </label>
        <span class="helpmode-label ms-2">Hilfemodus</span>
      </div>
    }
    <div class="sidebar sidebar-test" (clickOutside)="closeMenu()" [ngClass]="{ expanded: isExpanded }">
      <div class="header">
        <img
          (click)="goHome()"
          [src]="isMerckTenant ? './assets/Images/logo-merck.svg' : (isExpanded ? './assets/Images/Logo2.png' : './assets/Images/ING Logo2.png')"
          [class]="isExpanded ? 'logo-expanded' : 'logo-collapsed'"
          />
        <div class="toggle position-absolute close-mobile-icon" style="right: 1.25rem" (click)="handleSidebarToggle()">
          <span class="icon-close"></span>
        </div>
      </div>
      <div class="mt-4 mb-3">
        @if (
          (tenantInnerService.tenants$ | async)!.length <= 1 &&
          !router.url.includes('/admin') &&
          !router.url.includes('/benutzermanagement') &&
          (tenantInnerService.isLoading$ | async) === false &&
          !isTablet
          ) {
          <span
            style="margin-top: 0.5rem"
            class="btn-like tenant w-100 d-flex"
          [ngClass]="
            (tenantInnerService.tenants$ | async)!.length <= 1 && !isExpanded
              ? 'pl-2 ml-1'
              : (tenantInnerService.tenants$ | async)!.length <= 1 && isExpanded
                ? 'pl-2 ml-2'
                : ''
          "
            >
            @if (isExpanded) {
              <span class="icon-marker"></span>
              <span class="mr-auto tenant-name">{{ (tenantInnerService.curTenant$ | async)?.displayName }}</span>
            }
            @if (!isExpanded) {
              <div class="name-wrapper">
                <span class="mr-auto">{{ $safeNavigationMigration((tenantInnerService.curTenant$ | async)?.displayName) | shortName }}</span>
              </div>
            }
          </span>
        }
      </div>
      @if (
        isMobile &&
        isExpanded &&
        (tenantInnerService.tenants$ | async)!.length > 1 &&
        !router.url.includes('/admin') &&
        !router.url.includes('/benutzermanagement') &&
        (tenantInnerService.isLoading$ | async) === false
        ) {
        <div
          class="btn tenant w-100 d-flex pl-3 align-items-center"
          [popover]="tenantsTemplate"
          placement="bottom"
          #pop="bs-popover"
          [outsideClick]="true"
          >
          <span class="icon-marker"></span>
          <span class="mr-auto tenant-name">{{ (tenantInnerService.curTenant$ | async)?.displayName }}</span>
          <span class="icon-caret-down ml-auto mt-1"></span>
        </div>
      }
      <div
        class="content menu"
        [ngClass]="{ 'menu-mobile': isMobile, 'content-menu-admin': isAdminView, 'menu-merck': isMerckTenant }"
        >
        @if (!isUserManagement) {
          <div class="link">
            <a
              class="content"
              [routerLink]="isAdminView ? ['/admin'] : ['/']"
              [ngClass]="router.url === '/' || router.url === '/admin' ? 'active' : ''"
              >
              <div class="icon">
                <span class="icon-home"></span>
              </div>
              <div class="title">Startseite</div>
            </a>
          </div>
        }
        <!--User view-->
        @if (!isAdminView && !isUserManagement && hasFeature(Feature.Maps)) {
          <div class="link">
            <a class="content" [routerLink]="['/maps']" [routerLinkActive]="'active'">
              <div class="icon">
                <span class="icon-maps"></span>
              </div>
              <div class="title">Karten</div>
            </a>
          </div>
        }
        @if (!isAdminView && !isUserManagement && hasFeature(Feature.Questionnaire)) {
          <div class="link">
            <a class="content" [routerLink]="['/questionnaire-user']" [routerLinkActive]="'active'">
              <div class="icon">
                <span class="icon-questionary"></span>
              </div>
              <div class="title">Fragen</div>
            </a>
          </div>
        }
        @if (!isAdminView && !isUserManagement && hasFeature(Feature.Transformation)) {
          <div class="link">
            <a class="content" [routerLink]="['/transformation']" [routerLinkActive]="'active'">
              <div class="icon">
                <span class="icon-tool"></span>
              </div>
              <div class="title">Toolbox</div>
            </a>
          </div>
        }
        @if (!isAdminView && !isUserManagement && hasFeature(Feature.ConstructionDocument)) {
          <div class="link">
            <a class="content" [routerLink]="['/baustellendokumentation']" [routerLinkActive]="'active'">
              <div class="icon">
                <span class="icon-site-documentation"></span>
              </div>
              <div class="title">Baustellendoku</div>
            </a>
          </div>
        }
        @if (!isAdminView && !isUserManagement && (hasFeature(Feature.BuildingRiskUser) || hasFeature(Feature.BuildingRiskEditor) || hasFeature(Feature.Nivus) || isMerckFloodMapAvailable)) {
          <div
            class="dropdown link"
            dropdown
            #gebaeudebewertungDropdown="bs-dropdown"
            (isOpenChange)="onDropdownOpen($event, 'gebaeudebewertung')"
            [autoClose]="!isExpanded"
            >
            <div
              dropdownToggle
              class="dropdown-toggle content"
              (click)="expandForGroup()"
              [ngClass]="router.url.includes('/irap') ? 'active' : ''"
              >
              <div class="icon">
                <span class="icon-rain"></span>
                @if (!isExpanded) {
                  <span class="icon-plus small"></span>
                }
              </div>
              <div class="title">IRAP</div>
              <i class="icon-plus"></i>
            </div>
            <ul
              *dropdownMenu
              class="dropdown-menu pt-0"
              role="menu"
              (click)="closeExpanded()"
              >
              @if (hasFeature(Feature.BuildingRiskUser) || hasFeature(Feature.BuildingRiskEditor)) {
                <li role="menuitem">
                  <a class="dropdown-item" [routerLink]="['/irap/building-risk']" [routerLinkActive]="'active'"
                    >Gebäudebewertung</a
                    >
                  </li>
                }
                @if (hasFeature(Feature.Nivus)) {
                  <li role="menuitem">
                    <a class="dropdown-item" [routerLink]="['/irap/sensoren']" [routerLinkActive]="'active'">Sensoren</a>
                  </li>
                }
                @if (isMerckFloodMapAvailable) {
                  <li role="menuitem">
                    <a class="dropdown-item" [routerLink]="['/irap/überflutung']" [routerLinkActive]="'active'">Überflutung</a>
                  </li>
                }
              </ul>
            </div>
          }
          @if (!isAdminView && !isUserManagement && hasFeature(Feature.ExternalTicket)) {
            <div
              class="link"
              >
              <a class="content" [routerLink]="['/external-tickets']" [routerLinkActive]="'active'">
                <div class="icon">
                  <span class="icon-support"></span>
                </div>
                <div class="title">WorkflowCenter</div>
              </a>
            </div>
          }
          @if (!isAdminView && !isUserManagement && hasAnyAbwasserFeature) {
            <div
              class="dropdown link"
              dropdown
              #abwasserDropdown="bs-dropdown"
              (isOpenChange)="onDropdownOpen($event, 'abwasser')"
              [autoClose]="!isExpanded"
              >
              <div
                dropdownToggle
                class="dropdown-toggle content"
                (click)="expandForGroup()"
                [ngClass]="router.url.includes('/wastewater') || router.url.includes('/construction') ? 'active' : ''"
                >
                <div class="icon">
                  <span class="icon-manhole"></span>
                  @if (!isExpanded) {
                    <span class="icon-plus small"></span>
                  }
                </div>
                <div class="title">Abwasser</div>
                <i class="icon-plus"></i>
              </div>
              <ul
                *dropdownMenu
                class="dropdown-menu pt-0"
                role="menu"
                (click)="closeExpanded()"
                >
                @if (hasFeature(Feature.Tickets)) {
                  <li role="menuitem">
                    <a class="dropdown-item" [routerLink]="['/wastewater/errors&ambiguities']" [routerLinkActive]="'active'"
                      >Änderungen</a
                      >
                    </li>
                  }
                  @if (hasFeature(Feature.ConstructionSite)) {
                    <li role="menuitem">
                      <a class="dropdown-item" [routerLink]="['/construction']" [routerLinkActive]="'active'">Baustellen</a>
                    </li>
                  }
                  @if (hasFeature(Feature.SewerDashboard)) {
                    <li role="menuitem">
                      <a class="dropdown-item" [routerLink]="['/wastewater/dashboard']" [routerLinkActive]="'active'"
                        >Dashboard</a
                        >
                      </li>
                    }
                    @if (hasFeature(Feature.Upload)) {
                      <li role="menuitem">
                        <a class="dropdown-item" [routerLink]="['/wastewater/upload-content']" [routerLinkActive]="'active'"
                          >Datenupload</a
                          >
                        </li>
                      }
                      @if (hasFeature(Feature.DataExport)) {
                        <li role="menuitem">
                          <a class="dropdown-item" [routerLink]="['/wastewater/data-export']" [routerLinkActive]="'active'"
                            >Datenexport</a
                            >
                          </li>
                        }
                        @if (hasFeature(Feature.DataCheck)) {
                          <li role="menuitem">
                            <a class="dropdown-item" [routerLink]="['/wastewater/data-check']" [routerLinkActive]="'active'"
                              >Datenprüfung</a
                              >
                            </li>
                          }
                          @if (hasFeature(Feature.EngineersDamageClass)) {
                            <li role="menuitem">
                              <a class="dropdown-item" [routerLink]="['/wastewater/engineer-tool']" [routerLinkActive]="'active'"
                                >Ingenieursklasse</a
                                >
                              </li>
                            }
                            @if (hasFeature(Feature.PipeInspection) || hasFeature(Feature.PipeInspectionEditor)) {
                              <li role="menuitem">
                                <a class="dropdown-item" [routerLink]="['/wastewater/pipe-inspection']" [routerLinkActive]="'active'"
                                  >Kanalrohre</a
                                  >
                                </li>
                              }
                              @if (hasFeature(Feature.AdoptionPipeInspection)) {
                                <li role="menuitem">
                                  <a class="dropdown-item" [routerLink]="['/wastewater/kanalyze']" [routerLinkActive]="'active'"
                                    >Kanalyze</a
                                    >
                                  </li>
                                }
                                @if (hasFeature(Feature.SewerTinderV2)) {
                                  <li role="menuitem">
                                    <a
                                      class="dropdown-item"
                                      [routerLink]="['/wastewater/remediation-measures']"
                                      [routerLinkActive]="'active'"
                                      (click)="reNavigate('/wastewater/remediation-measures')"
                                      >Sanierungsmaßnahmen</a
                                      >
                                    </li>
                                  }
                                  @if (hasFeature(Feature.SewerTinderV3)) {
                                    <li role="menuitem">
                                      <a
                                        class="dropdown-item"
                                        [routerLink]="['/wastewater/damage-assessment']"
                                        [routerLinkActive]="'active'"
                                        (click)="reNavigate('/wastewater/damage-assessment')"
                                        >Schadensbewertung</a
                                        >
                                      </li>
                                    }
                                    @if (hasFeature(Feature.ManholeInspection)) {
                                      <li role="menuitem">
                                        <a class="dropdown-item" [routerLink]="['/wastewater/manhole-inspection']" [routerLinkActive]="'active'"
                                          >Schächte</a
                                          >
                                        </li>
                                      }
                                      @if (hasFeature(Feature.SewerTinder)) {
                                        <li role="menuitem">
                                          <a class="dropdown-item" [routerLink]="['/wastewater/immediate-actions']" [routerLinkActive]="'active'"
                                            >Sofortmaßnahmen</a
                                            >
                                          </li>
                                        }
                                        @if (hasFeature(Feature.SpecialSystem)) {
                                          <li role="menuitem">
                                            <a class="dropdown-item" [routerLink]="['/wastewater/special-system']" [routerLinkActive]="'active'"
                                              >Sonderbauwerke</a
                                              >
                                            </li>
                                          }
                                        </ul>
                                      </div>
                                    }
                                    <!-- User Management -->
                                    @if (isUserManagement) {
                                      <div class="link">
                                        <a class="content" [routerLink]="['/benutzermanagement/manage-access']" [routerLinkActive]="'active'">
                                          <div class="icon">
                                            <span class="icon-users"></span>
                                          </div>
                                          <div class="title">Benutzerverwaltung</div>
                                        </a>
                                      </div>
                                    }
                                    <!--Admin view-->
                                    @if (isAdminView) {
                                      <div class="link">
                                        <a class="content" [routerLink]="['/admin/upload-content']" [routerLinkActive]="'active'">
                                          <div class="icon">
                                            <span class="icon-upload-2"></span>
                                          </div>
                                          <div class="title">DataUpload</div>
                                        </a>
                                        <a class="content" [routerLink]="['/admin/manage-access']" [routerLinkActive]="'active'">
                                          <div class="icon">
                                            <span class="icon-users"></span>
                                          </div>
                                          <div class="title">Manage Access</div>
                                        </a>
                                      </div>
                                    }
                                    @if (isAdminView) {
                                      <div class="link">
                                        <a class="content" [routerLink]="['/admin/subscriptions']" [routerLinkActive]="'active'">
                                          <div class="icon">
                                            <span class="icon-subscription"></span>
                                          </div>
                                          <div class="title">Subscriptions</div>
                                        </a>
                                      </div>
                                    }
                                    @if (isAdminView) {
                                      <div class="link">
                                        <a class="content" [routerLink]="['/admin/maps']" [routerLinkActive]="'active'">
                                          <div class="icon">
                                            <span class="icon-maps"></span>
                                          </div>
                                          <div class="title">Maps</div>
                                        </a>
                                      </div>
                                    }
                                    @if (isAdminView) {
                                      <div class="link">
                                        <a class="content" [routerLink]="['/admin/apps/questionnaires']" [routerLinkActive]="'active'">
                                          <div class="icon">
                                            <span class="icon-questionary"></span>
                                          </div>
                                          <div class="title">Questions</div>
                                        </a>
                                      </div>
                                    }
                                    @if (isAdminView) {
                                      <div class="link">
                                        <a class="content" [routerLink]="['/admin/errors&ambiguities']" [routerLinkActive]="'active'">
                                          <div class="icon">
                                            <span class="icon-support"></span>
                                          </div>
                                          <div class="title">Tickets</div>
                                        </a>
                                      </div>
                                    }
                                    @if (isAdminView) {
                                      <div
                                        class="dropdown link"
                                        dropdown
                                        #invoicingDropdown="bs-dropdown"
                                        [autoClose]="!isExpanded"
                                        (isOpenChange)="onDropdownOpen($event, 'invoicing')"
                                        (onShown)="closeOtherDropdowns('invoicing')"
                                        >
                                        <div
                                          dropdownToggle
                                          class="dropdown-toggle content"
                                          (click)="expandForGroup()"
                                          [ngClass]="router.url.includes('/admin/invoice') ? 'active' : ''"
                                          >
                                          <div class="icon">
                                            <span class="icon-invoice"></span>
                                            @if (!isExpanded) {
                                              <span class="icon-plus small"></span>
                                            }
                                          </div>
                                          <div class="title">Invoicing</div>
                                          <i class="icon-plus"></i>
                                        </div>
                                        <ul
                                          *dropdownMenu
                                          class="dropdown-menu pt-0 marketing-menu"
                                          role="menu"
                                          (click)="closeExpanded()"
                                          >
                                          <li role="menuitem" class="marketing-menu-item">
                                            <a class="dropdown-item" [routerLink]="['/admin/invoice-reports']" [routerLinkActive]="'active'"
                                              >Invoice Report</a
                                              >
                                            </li>
                                            <li role="menuitem">
                                              <a class="dropdown-item" [routerLink]="['/admin/invoices']" [routerLinkActive]="'active'"
                                                >Invoice Assignment</a
                                                >
                                              </li>
                                            </ul>
                                          </div>
                                        }
                                        @if (isAdminView) {
                                          <div
                                            class="dropdown link"
                                            dropdown
                                            #marketingDropdown="bs-dropdown"
                                            [autoClose]="!isExpanded"
                                            (onShown)="closeOtherDropdowns('marketing')"
                                            >
                                            <div
                                              dropdownToggle
                                              class="dropdown-toggle content"
                                              (click)="expandForGroup()"
                                              [ngClass]="router.url.includes('/marketing') ? 'active' : ''"
                                              >
                                              <div class="icon">
                                                <span class="icon-tool"></span>
                                                @if (!isExpanded) {
                                                  <span class="icon-plus small"></span>
                                                }
                                              </div>
                                              <div class="title">Marketing</div>
                                              <i class="icon-plus"></i>
                                            </div>
                                            <ul
                                              *dropdownMenu
                                              class="dropdown-menu pt-0 marketing-menu"
                                              role="menu"
                                              (click)="closeExpanded()"
                                              >
                                              <li role="menuitem" class="marketing-menu-item">
                                                <a class="dropdown-item" [routerLink]="['/admin/marketing/announcements']" [routerLinkActive]="'active'"
                                                  >Announcements</a
                                                  >
                                                </li>
                                                <li role="menuitem">
                                                  <a class="dropdown-item" [routerLink]="['/admin/marketing/events']" [routerLinkActive]="'active'"
                                                    >Events</a
                                                    >
                                                  </li>
                                                </ul>
                                              </div>
                                            }
                                            <div class="footer">
                                              @if (!isAdminRole && (isPartnerAdmin || isTenantAdmin)) {
                                                <div class="link">
                                                  <a class="content" [href]="isUserManagement ? '/' : '/benutzermanagement'" (click)="goToUserManagementDashboard($event)">
                                                    <div class="icon">
                                                      <span class="icon-refresh"></span>
                                                    </div>
                                                    <div class="title d-flex title-switch">
                                                      {{ isUserManagement ? 'Benutzeransicht' : 'Benutzermanagement' }}
                                                    </div>
                                                  </a>
                                                </div>
                                              }
                                              @if (isAdminRole) {
                                                <div class="link">
                                                  <a class="content" [href]="isAdminView ? '/' : '/admin'" (click)="GoToAdminDashboard($event)">
                                                    <div class="icon">
                                                      <span class="icon-refresh"></span>
                                                    </div>
                                                    <div class="title d-flex title-switch">
                                                      {{ isAdminView ? 'To User View' : 'To Admin View' }}
                                                      @if (!isAdminView && adminNotificationCount > 0) {
                                                        <span class="notification-count">{{
                                                          adminNotificationCount
                                                        }}</span>
                                                      }
                                                    </div>
                                                  </a>
                                                </div>
                                              }
                                              @if (!isAdminView) {
                                                <div class="link">
                                                  <a class="content" [routerLink]="['/settings']" [routerLinkActive]="'active'">
                                                    <div class="icon">
                                                      <span class="icon-settings"></span>
                                                    </div>
                                                    <div class="title">Einstellungen</div>
                                                  </a>
                                                </div>
                                              }
                                              @if (isAdminView) {
                                                <div class="link">
                                                  <a class="content" [routerLink]="['/admin/settings']" [routerLinkActive]="'active'">
                                                    <div class="icon">
                                                      <span class="icon-settings"></span>
                                                    </div>
                                                    <div class="title">Settings</div>
                                                  </a>
                                                </div>
                                              }
                                              @if (!isMobile) {
                                                <div class="link" (click)="handleSidebarToggle()">
                                                  <div class="content">
                                                    <div class="icon">
                                                      <span class="icon-arrow-forward"></span>
                                                    </div>
                                                    <div class="title">Menü einklappen</div>
                                                  </div>
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      @if (!router.url.includes('/admin')) {
                                        <app-notifications
                                          class="notificaions-wrapper mobile-view"
                                        ></app-notifications>
                                      }
                                      <i
                                        class="icon-user-profile icon-menu"
                                        [popover]="headerTemplate"
                                        containerClass="profile-popover-class"
                                        placement="bottom"
                                        #pop="bs-popover"
                                        [outsideClick]="true"
                                      ></i>
                                      @if (!isMobile) {
                                        <div class="tenant-small" [ngClass]="{ 'tenant-small-expanded': isExpanded }">
                                          @if (
                                            (tenantInnerService.tenants$ | async)!.length > 1 &&
                                            !router.url.includes('/admin') &&
                                            !router.url.includes('/benutzermanagement') &&
                                            (tenantInnerService.isLoading$ | async) === false
                                            ) {
                                            <div
                                              class="btn tenant w-100 d-flex"
                                              [popover]="tenantsTemplate"
                                              placement="bottom"
                                              #pop="bs-popover"
                                              [ngClass]="{ 'pr-0': !isExpanded, 'pl-3': !isExpanded }"
                                              [outsideClick]="true"
                                              >
                                              @if (isExpanded) {
                                                <span class="icon-marker"></span>
                                                <span class="mr-auto tenant-name">{{ (tenantInnerService.curTenant$ | async)?.displayName }}</span>
                                              }
                                              @if (!isExpanded) {
                                                <div class="name-wrapper">
                                                  <span class="mr-auto">{{ $safeNavigationMigration((tenantInnerService.curTenant$ | async)?.displayName) | shortName }}</span>
                                                </div>
                                              }
                                              <span class="icon-caret-down ml-auto" [ngClass]="{ 'mt-1': !isExpanded, 'ml-auto': isExpanded }"></span>
                                            </div>
                                          }
                                        </div>
                                      }
                                    </div>
                                    @if (isMobile && tenants.length > 1 && !router.url.includes('/admin') && !isLoading && !top) {
                                      <div
                                        class="d-flex justify-content-start tenant-sticky-wrapper w-100"
                                        >
                                        <div
                                          class="tenant-sticky font-w-600 d-flex"
                                          [popover]="tenantTemplate"
                                          #pop="bs-popover"
                                          [outsideClick]="true"
                                          [containerClass]="'mt-0 ml-2 br-16'"
                                          >
                                          <i class="icon-marker"></i>
                                          <p class="tenant-name ml-2 mr-2 mb-0">{{ (tenantInnerService.curTenant$ | async)?.displayName }}</p>
                                          <i class="icon-arrow-down"></i>
                                        </div>
                                      </div>
                                    }
                                    <ng-template #tenantTemplate>
                                      <ul
                                        class="header-menu ps-0 w-100 tenants-list custom-scrollbar"
                                        [ngClass]="{ 'tenants-list-mobile': isMobile || isTablet }"
                                        >
                                        @for (item of tenants; track item) {
                                          <li
                                            data-tooltip-no-anchor
                                            class="my-1 tenant-item"
                                            [ngClass]="{ 'selected-tenant': item.name === curTenant!.name, 'px-1': isMobile, 'px-3': !isMobile }"
                                            >
                                            <span (click)="SetTenant(item); pop.hide()">
                                              {{ item.displayName }}
                                              @if (item.name === curTenant!.name) {
                                                <span class="icon-check"></span>
                                              }
                                            </span>
                                          </li>
                                        }
                                      </ul>
                                    </ng-template>
                                    <ng-template #headerTemplate>
                                      <div class="profile-template">
                                        <p class="user-name m-0">{{ userName }}</p>
                                        <p class="border-bottom m-0 pb-4">{{ userEmail }}</p>
                                        <ul class="m-0">
                                          <li (click)="manageAccount(); pop.hide()"><i class="icon-settings mr-2"></i>Konto verwalten</li>
                                          <li (click)="logout()"><i class="icon-upload mr-2"></i> Logout</li>
                                        </ul>
                                      </div>
                                    </ng-template>
                                    <ng-template #tenantsTemplate>
                                      <ul
                                        class="header-menu ps-0 w-100 tenants-list custom-scrollbar"
                                        [ngClass]="{ 'tenants-list-mobile': isMobile || isTablet }"
                                        >
                                        @for (item of tenantInnerService.tenants$ | async; track item) {
                                          <li
                                            data-tooltip-no-anchor
                                            class="py-0 px-3 tenant-item"
                                            [ngClass]="item.name === (tenantInnerService.curTenant$ | async)?.name ? 'selected-tenant' : ''"
                                            >
                                            <span (click)="switchTenant(item); pop.hide()">
                                              {{ item.displayName }}
                                              @if (item.name === curTenant!.name) {
                                                <span class="icon-check"></span>
                                              }
                                            </span>
                                          </li>
                                        }
                                      </ul>
                                    </ng-template>
